import { useState } from 'react';
import AuthService from '../../../services/auth_service';
import ContactService from '../../../services/contact_service';

const Login = ({ onLogin, message }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await AuthService.login(email, password);
            const user = await AuthService.getContactFromToken();
            const updateUser = await ContactService.update(user?.Id, {
                IncomeNumber: user.IncomeNumber + 1,
            });
            message("Sesión Iniciada", "success")
            onLogin(updateUser);
        } catch (e) {
            message(e?.message || e, "error");
        } finally {
            setLoading(false)
        }
    };

    return {
        email,
        password,
        loading,
        setEmail,
        setPassword,
        handleSubmit
    };
};

export default Login;
